<template>
  <div class="application-rating">
    <div v-if="showRatePanel" class="form-group">
      <label class="control-label">Your rating</label>
      <div class="row">
        <div class="col-sm-12">
          <StartupRate v-model="rating" />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4">
          <Fader ref="saveIndicator">
            <span class="text-success">Saved</span>
          </Fader>
        </div>
      </div>
    </div>

    <div v-if="showRatePanel" class="form-group">
      <label class="control-label">Your comments</label>
      <textarea
        v-model="note"
        v-autosize
        placeholder="Type your notes here"
        rows="1"
        class="form-control overview-input"
      ></textarea>
    </div>

    <div class="form-group text-muted other-users-ratings">
      <label class="control-label">Other users' ratings</label>
      <p v-show="!showOtherUsersRatings">
        <span v-if="otherUsersRatings.length">
          There are ratings from {{ otherUsersRatings.length }} other users.
          They would be shown once you send your rating.
        </span>
        <span v-if="!otherUsersRatings.length"
          >There are no ratings from other users yet.</span
        >
      </p>
      <div v-show="showOtherUsersRatings">
        <div
          v-for="userRating in otherUsersRatings"
          :key="userRating.user.id"
          class="user-rating row"
        >
          <div class="col-sm-12 col-md-6 col-lg-4">
            <StartupRate :value="userRating.overall" read-only muted />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            {{ userRating.user.email }}
          </div>
          <div class="col-sm-12 col-md-12 col-lg-4">
            <p>{{ userRating.note }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label">Average rating</label>
      <StartupRate
        :value="averageRatingFixed"
        read-only
        :muted="!showOtherUsersRatings"
      />
    </div>
  </div>
</template>

<script>
import autosize from '@/directives/autosize'
import StartupRate from '@/components/StartupRate.vue'
import { mapGetters, mapState } from 'vuex'
import Fader from '@/components/Fader'

export default {
  directives: { autosize },
  components: { Fader, StartupRate },
  computed: {
    rating: {
      get() {
        return this.application.ratings.mine.overall || 0
      },
      async set(rating) {
        if (rating) {
          const note = this.note
          this.saveAndFetch({ rating, note })
        }
      },
    },
    note: {
      get() {
        return this.application.ratings.mine.note || ''
      },
      set(note) {
        const rating = this.rating
        this.$store.commit(
          'organizationProgramApplicationDetails/SET_NOTE',
          note,
        )
        this.debouncedSaveAndFetch({ rating, note })
      },
    },
    showRatePanel() {
      return this.user.isOrganizer
    },
    showOtherUsersRatings() {
      return this.user.isAdmin || this.rating > 0
    },
    ...mapState({
      application: (state) =>
        state.organizationProgramApplicationDetails.application,
      otherUsersRatings: (state) =>
        state.organizationProgramApplicationDetails.application.ratings.others,
      user: (state) => state.user.data,
    }),
    ...mapGetters({
      averageRatingFixed:
        'organizationProgramApplicationDetails/averageRatingFixed',
    }),
  },
  methods: {
    debouncedSaveAndFetch: _.debounce(function ({ rating, note }) {
      this.saveAndFetch({ rating, note })
    }, 1000),
    async saveAndFetch({ rating, note }) {
      await this.$store.dispatch(
        'organizationProgramApplicationDetails/saveRating',
        { rating, note },
      )
      this.$refs.saveIndicator.show()
      this.$store.dispatch('organizationProgramApplications/silentFetch', {
        organizationId: this.application.organization_id,
        programId: this.application.program_id,
      })
    },
    saveNote() {
      const rating = this.rating
      const note = this.note
      if (rating > 0) {
        this.saveAndFetch({ rating, note })
      }
    },
  },
}
</script>

<style lang="scss">
.application-rating {
  .other-users-ratings {
    margin-top: 30px;
  }
}
</style>
